var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auction-dialog', {
    attrs: {
      "title": "설치 및 보관 안내"
    },
    on: {
      "open": _vm.init
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', [_c('h4', {
          staticClass: "font-size-16 font-size-18 mb-2 mb-md-4"
        }, [_vm._v("설치")]), _c('p', {
          staticClass: "font-size-14 line-height-16 primary--text"
        }, [_vm._v("당사 낙찰 작품에 한하여 배송 시 설치를 함께 요청하실 수 있으며, 사전 예약이 필요합니다.")]), _c('div', {
          staticClass: "mt-8 mt-md-12"
        }, [_c('v-card', {
          staticClass: "grey-ef",
          attrs: {
            "tile": "",
            "elevation": "0"
          }
        }, [_c('v-card-text', {
          staticClass: "pa-16 pa-md-24"
        }, [_c('ul', {
          staticClass: "dot-list"
        }, [_c('li', [_vm._v("80호 미만은 점당 3만원(추가 점당 1만원), 80호 이상은 점당 10만원(추가 점당 2만원)의 비용이 발생합니다.")]), _c('li', [_vm._v("대리석, 콘크리트, 가벽, 레일 등 현장 난이도에 따라 비용이 추가될 수 있습니다.")]), _c('li', [_vm._v("예약 없이 요청하시는 경우, 배송일정에 따라 바로 설치를 해드리기 어려울 수 있습니다.")])])])], 1)], 1)]), _c('div', {
          staticClass: "mt-14 mt-md-18"
        }, [_c('h4', {
          staticClass: "font-size-16 font-size-18 mb-2 mb-md-4"
        }, [_vm._v("보관")]), _c('p', {
          staticClass: "font-size-14 line-height-16 primary--text"
        }, [_vm._v("낙찰 및 판매 이후 7일 경과 시 입금여부와 무관하게 일 30,000원/점의 비용이 발생합니다.")])])];
      },
      proxy: true
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }